<script>
import {imagesLoad} from '@/util/assetLoadUtil';

import playIcon from '@/assets/img/soundPlayer/play.svg';

export default {
  name: 'hoverDesign',
  components: {
  },
  data() {
    return {
    };
  },
  props: {
    hoverDesign: {// parallelogram, playMovie, verticalSquare, horizonSquare, checkered
      type: String,
      default: 'parallelogram',
    },
    hoverColor: { // black, white
      type: String,
      default: 'black',
    }
  },
  created() {
    imagesLoad([
      playIcon,
    ]);
  },
};
</script>

<template>
  <div class="hover-container" :class="[hoverDesign, hoverColor]">
    <div class="bg1"></div>
    <div class="bg2"></div>
    <div class="bg3"></div>
    <div class="bg4"></div>
    <div class="bgItem1"></div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .hover-container {
    @include absolute100;
    overflow: hidden;
    cursor: pointer;
    // 色
    &.black {
      .bg1, .bg2, .bg3, .bg4 {background: $bgColorA50;}
    }
    &.white {
      .bg1, .bg2, .bg3, .bg4 {background: $textColorA50;}
    }
    
    // タイプ
    &.parallelogram {
      .bg1, .bg2{
        height: 100%;
        width: 0%;
        position: absolute;
        transform: skewX(-45deg);
        transition: 0.2s ease;
      }
      .bg1{left: -50%;}
      .bg2{right: -50%;}
      
      &:hover {
        .bg1, .bg2{
          width: 100%;
        }
      }
    }

    &.playMovie {
      .bg1, .bg2{
        height: 100%;
        width: 0%;
        position: absolute;
        background: $textColorA50;
        transform: skewX(30deg);
        transition: 0.2s ease;
      }
      .bg1{left: -50%;}
      .bg2{right: -50%;}

      .bgItem1 {
        transition: 0.2s ease;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100px;
        height: 100px;
        margin: -50px 0 0 -50px;
        @include bgCenter;
        background-image: url(../assets/img/decoration/play.svg);
        transform-origin: 50% 50%;
        transform: scale(0) rotate(180deg);
      }
      
      &:hover {
        .bg1, .bg2{
          width: 100%;
        }
        .bgItem1 {
          transform: scale(1) rotate(0deg);
        }
      }
    }

    &.verticalSquare {
      .bg1, .bg2{
        height: 0%;
        width: 50%;
        position: absolute;
        transition: 0.2s ease;
      }
      .bg1{left: 0; top: 0;}
      .bg2{right: 0; bottom: 0;}
      
      &:hover {
        .bg1, .bg2{
          height: 100%;
        }
      }
    }

    &.horizonSquare {
      .bg1, .bg2{
        height: 50%;
        width: 0%;
        position: absolute;
        transition: 0.2s ease;
      }
      .bg1{left: 0; bottom: 0;}
      .bg2{right: 0; top: 0;}
      
      &:hover {
        .bg1, .bg2{
          width: 100%;
        }
      }
    }


    &.checkered {
      .bg1, .bg2, .bg3, .bg4{
        position: absolute;
        transition: 0.2s ease;
      }
      .bg1, .bg2{
        height: 0%;
        width: 50%;
      }
      .bg3, .bg4{
        height: 50%;
        width: 0%;
      }
      .bg1{left: 0; top: 0;}
      .bg2{right: 0; bottom: 0;}
      .bg3{left: 0; bottom: 0;}
      .bg4{right: 0; top: 0;}
      
      &:hover {
        .bg1, .bg2{
          height: 50%;
        }
        .bg3, .bg4{
          width: 50%;
        }
      }
    }

  }
</style>
